<template>
  <div>
      <el-form :inline="true" style="border:solid 1px #e0dddd">

        <el-form-item>
          <el-select v-model="formInto.product_id" clearable placeholder="产品料号" filterable style="width: 200px;">
            <el-option v-for="item in productList" :key="item.value" :label="item.label" :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="queryMoldResume" type="primary">查询</el-button>
        </el-form-item>
      </el-form>

    <div style="font-weight:bold ;margin: 10px 0px 0px 20px;">产品信息:</div>

    <div style="overflow: auto">
      <FrameForm ref="formHeader" component-param="mes_mold_resume_header" :parentData="this.parentData"
                 style="border:solid 1px #e0dddd;padding: 5px"/>
    </div>

    <div style="font-weight:bold ;margin: 5px 0px 5px 20px;">模具履历:</div>

    <div style="overflow: auto" v-if="tabQuery">
      <FrameTab ref="tabQuery" component-param="mold_resume_tab" :parent-data="parentData"/>
    </div>
  </div>


</template>

<script>
export default {
  name: "MoldResume",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      formInto: {
        product_id :'',
        customer_product: '',
      },
      productList: [],
      parentData:{},
      tabQuery: false,

    };
  },
  computed: {},
  created() {
    this.getProductItem();
    this.tabQuery = true
  },
  mounted() {
  },
  methods: {

    //获取产品料号
    async getProductItem() {
      this.productList = await this.$http("mesMoldDsService.getProductAll")
    },

    //搜索模具履历
    async queryMoldResume() {

      //清空数据
      // this.clearData();

      if (!this.formInto.product_id) {
        return
      }

      this.product = await this.$http("mesMoldResumeService.getProduct", this.formInto);
      this.parentData.product_id = this.product.product_id;
      this.parentData.mold_list = this.product.mold_list;
      this.parentData.product_name = this.product.product_name;
      this.parentData.customer_product = this.product.customer_product;

      this.tabQuery = false;
      setTimeout(() => {
        this.tabQuery = true;
      }, 10);

      await this.$refs.formHeader.initForm();
    }

  }
}
</script>

<style scoped>

.el-form--inline .el-form-item {
  margin: 10px 10px 10px 10px;
}

:deep(.el-form-item[data-v-ec0302b9]) {
  margin-bottom: 0px
}

</style>